import { useParams } from 'react-router';
import { StudentListDetailsComponent } from './StudentListDetailsComponent';

type Params = { sessionEnrollmentId: string };

export function StudentRiskHistoryDetails() {
  const params = useParams<Params>();

  return (
    <StudentListDetailsComponent
      sessionEnrollmentId={params.sessionEnrollmentId}
      origin="riskSessionHistory"
    />
  );
}
